import React from 'react';
import { Modal } from 'react-bootstrap';
import { BsCheckBox, BsArrowRight, BsChevronRight, BsArrowRepeat, BsX } from "react-icons/bs/index.js";
import { ESTADOS_NOMINA } from './StatusBadge';
import './nomina.css';

// Etiqueta de estado con los mismos colores de la tabla
const Estado = ({ e }) => <span className={`nom-pill nom-estado-${e}`}>{ESTADOS_NOMINA[e]}</span>;
const Flecha = () => <BsArrowRight className="nom-manual-flecha" aria-hidden="true" />;

const Paso = ({ n, titulo, children, nota }) => (
  <div className="nom-manual-paso">
    <div className="nom-manual-num" aria-hidden="true">{n}</div>
    <div>
      <p className="nom-manual-titulo">{titulo}</p>
      <div className="nom-manual-ilustracion">{children}</div>
      <p className="nom-manual-nota">{nota}</p>
    </div>
  </div>
);

// Mini manual de Gestión de Nóminas (botón "i" de la tarjeta del título)
const ManualNomina = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered dialogClassName="nom-manual-dialog" aria-labelledby="nom-manual-titulo">
    <div className="nom-manual">
      <div className="nom-manual-header">
        <div>
          <p id="nom-manual-titulo" className="nom-manual-h">Cómo usar Gestión de Nóminas</p>
          <p className="nom-manual-sub">Guía rápida</p>
        </div>
        <button type="button" className="nom-manual-cerrar" onClick={onHide} aria-label="Cerrar">
          <BsX />
        </button>
      </div>

      <div className="nom-manual-body">
        <Paso n="1" titulo="Aprobar documentos"
          nota="Elige el periodo, marca los documentos y apruébalos. Se envían a la DIAN en segundo plano.">
          <span className="nom-chip">202609</span>
          <Flecha />
          <span className="nom-manual-texto"><BsCheckBox className="nom-manual-check" aria-hidden="true" /> Por Aprobación</span>
          <Flecha />
          <span className="nom-manual-aprobar">Aprobar Seleccionados</span>
        </Paso>

        <Paso n="2" titulo="Seguir el estado"
          nota={<React.Fragment>La tabla se actualiza automáticamente. Puedes seguir trabajando y volver cuando quieras: el estado quedará al día. Si la DIAN rechaza un documento, pasa a <strong className="nom-manual-error">Error DIAN</strong>.</React.Fragment>}>
          <Estado e="5" /><BsChevronRight className="nom-manual-flecha" aria-hidden="true" />
          <Estado e="0" /><BsChevronRight className="nom-manual-flecha" aria-hidden="true" />
          <Estado e="1" /><BsChevronRight className="nom-manual-flecha" aria-hidden="true" />
          <Estado e="2" />
        </Paso>

        <Paso n="3" titulo="Revisar un error"
          nota="Reprocesar lo devuelve a Por Aprobación para enviarlo de nuevo.">
          <Estado e="3" />
          <Flecha />
          <span className="nom-manual-texto nom-manual-link">Leer observación</span>
          <Flecha />
          <span className="nom-manual-texto">Corregir dato</span>
          <Flecha />
          <span className="nom-manual-icono" aria-label="Reprocesar"><BsArrowRepeat /></span>
        </Paso>
      </div>
    </div>
  </Modal>
);

export default ManualNomina;



// WEBPACK FOOTER //
// ./src/components/nomina/components/ManualNomina.jsx